<template>
  <div>
  <div v-if="!clientDetail" class="loading-message text-center p-4">
  <vs-progress indeterminate color="primary"></vs-progress>
  <p class="mt-2">Loading service data...</p>
</div>
    <vs-table
      v-else-if="serviceOveriewDetails && serviceOveriewDetails.length > 0"
      :max-items="descriptionItems[0]"
      class="service-order-tbl"
      :data="serviceOveriewDetails"
    >
      <template slot="header">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
          class="my-3"
        >
          <div style="font-size: 1.5rem; font-weight: 550">
            {{ $t("customers.label.service_overview") }}
          </div>
        </div>
        <div class="my-3">
          <Actions
            @orderChargingPopup="$emit('orderChargingPopup')"
            @redeemPopup="$emit('redeemPopup')"
            @depositPopup="$emit('depositPopup')"
            @recieverPopup="$emit('recieverPopup')"
            @topUpPopup="$emit('topUpPopup')"
            @renewalPopup="$emit('renewalPopup')"
          />
        </div>
      </template>
      <template slot="thead">
        <vs-th></vs-th>
        <vs-th class="w-25">{{ $t("customers.label.IMSI") }}</vs-th>
        <vs-th>{{ $t("customers.label.SalesMotion") }}</vs-th>
        <vs-th
          v-if="
            clientDetail &&
            clientDetail.billingInfo &&
            clientDetail.billingInfo.type !== 'Prepaid'
          "
        >
          {{ $t("customers.label.SpendCap") }}
        </vs-th>
        <vs-th class="thead-width">{{
          $t("customers.label.ActivationDate")
        }}</vs-th>
        <vs-th>{{ $t("customers.label.status") }}</vs-th>
        <!-- <vs-th>{{ $t("customers.label.temporary_block") }}</vs-th> -->
        <vs-th
          v-if="
            clientDetail &&
            clientDetail.billingInfo &&
            clientDetail.billingInfo.type === 'Prepaid'
          "
        >
          {{ $t("customers.label.slc_status") }}
        </vs-th>
        <vs-th class="tHeadCenter">{{ $t("customers.label.action") }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="index" :data="service" v-for="(service, index) in data">
          <vs-td>
            <vs-checkbox
              v-model="selectedService"
              @change="toggleSelection(service)"
            ></vs-checkbox>
          </vs-td>
          <vs-td :data="service.mobileNo" class="w-25">
            {{ service.mobileNo.imsi }}</vs-td
          >
          <vs-td :data="service.salesMotion">{{ service.salesMotion }}</vs-td>
          <vs-td
            :data="service.spendCap"
            v-if="
              clientDetail &&
              clientDetail.billingInfo &&
              clientDetail.billingInfo.type !== 'Prepaid'
            "
          >
            {{ (service.spendCap / 10000).toLocaleString() }}
          </vs-td>
          <vs-td :data="service.startDate">
            <span v-if="service.startDate != 'NA'">{{
              getDate(service.startDate)
            }}</span>
            <span v-else>NA</span>
          </vs-td>
          <vs-td :data="service.status">
            <vs-chip
              :color="
                accountStatus && accountStatus[0] === 0
                  ? getOrderStatusColor(service.status === 'DEACTIVE' ? 'Inactive' : service.status)
                  : 'danger'
              "
              class="product-order-status"
            >
              {{
                accountStatus && accountStatus[0] === 0
                  ? service.status === 'DEACTIVE' ? 'INACTIVE' : service.status
                  : 'Blocked'
              }}
            </vs-chip>
          </vs-td>
          <!-- <vs-td class="">
            <div class="container_img">
              N
            </div>
          </vs-td> -->
          <vs-td
            v-if="
              clientDetail &&
              clientDetail.billingInfo &&
              clientDetail.billingInfo.type === 'Prepaid'
            "
            class="w-25"
          >
            {{
              getSlcStatus(
                slcDataList && slcDataList[0] && slcDataList[0].currentState
              )
            }}
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <div class="container_img">
              <!--Don't remove this eye icon. This is important! Row click will disable other functionalities-->
              <feather-icon
                v-if="slcDataList && slcDataList.length > 0"
                :title="$t('customers.label.slc_state_history')"
                icon="ClockIcon"
                svgClasses="w-5 h-5 stroke-current text-primary"
                class="icon_row"
                @click.stop="viewSlcHistory()"
              />
              <feather-icon
                title="Service Details"
                icon="EyeIcon"
                svgClasses="w-5 h-5 stroke-current text-primary"
                class="icon_row"
                @click.stop="viewClientService(service)"
              />
              <feather-icon
                title=" View Allowance"
                icon="BarChart2Icon"
                svgClasses="w-5 h-5 stroke-current text-primary"
                class="icon_row"
                @click.stop="viewAllowanceData()"
              />
              <div>
                <vs-dropdown
                  v-if="service.status != 'TERMINATED'"
                  vs-custom-content
                  vs-trigger-click
                  class="cursor-pointer"
                >
                  <div class="con-img">
                    <feather-icon
                      title="More"
                      icon="MoreHorizontalIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="ml-2 icon_row"
                    />
                  </div>

                  <vs-dropdown-menu class="vx-navbar-dropdown">
                    <ul style="min-width: 13rem">
                      <li
                        v-if="
                          clientDetail &&
                          clientDetail.billingInfo &&
                          clientDetail.billingInfo.type === 'Postpaid'
                        "
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/addplan.svg"
                        />
                        <span
                          class="ml-2"
                          @click.stop="
                            $emit('spendCapPopup', service.spendCap, service.id)
                          "
                          >{{ $t("customers.label.SpendCap") }}</span
                        >
                      </li>
                      <li
                        v-if="service.status === 'ACTIVE'"
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/addplan.svg"
                        />
                        <span
                          @click.stop="
                            $emit(
                              'swapDevice',
                              service.clientServiceId,
                              service
                            )
                          "
                          class="ml-2"
                          >{{ $t("customers.label.swap_sim") }}</span
                        >
                      </li>
                      <li
                        v-if="service.status != 'PENDING'"
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/addplan.svg"
                        />
                        <span
                          @click="
                            addPlanPopup = true;
                            callAddPlans();
                            addPlanObj.clientServiceId =
                              service.clientServiceId;
                          "
                          class="ml-2"
                          >{{ $t("customers.label.add_plans") }}</span
                        >
                      </li>
                      <li
                        v-if="service.status.includes('SUSPENDED')"
                        class="flex py-2 px-3 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                      >
                        <img
                          class="w-6"
                          src="@/assets/images/icons/profile.png"
                        />
                        <span
                          class="ml-2"
                          @click.stop="reactivateService(service.id)"
                          >{{ $t("Promise to Pay") }}</span
                        >
                      </li>

                      <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/terminate.svg"
                        />
                        <span
                          class="ml-2"
                          @click="onClickTerminate(service)"
                          >{{ $t("customers.label.terminate") }}</span
                        >
                      </li>

                      <li
                        v-if="
                          clientDetail &&
                          clientDetail.billingInfo &&
                          clientDetail.billingInfo.type === 'Prepaid'
                        "
                        class="flex py-2 px-3 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                      >
                        <feather-icon
                          v-if="accountStatus && accountStatus[0] === 0"
                          icon="XCircleIcon"
                          svgClasses="w-4 h-4"
                        />
                        <feather-icon
                          v-else
                          icon="CheckCircleIcon"
                          svgClasses="w-4 h-4"
                        />
                        <span class="ml-2" @click.stop="updateAccountStatus">
                          {{
                            accountStatus && accountStatus[0] === 0
                              ? $t("customers.label.temporaryBlock")
                              : $t("customers.label.unBlock")
                          }}
                        </span>
                      </li>
                      <li
                        v-if="
                          clientDetail &&
                          clientDetail.billingInfo &&
                          clientDetail.billingInfo.type === 'Postpaid'
                        "
                        class="flex py-2 px-3 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                      >
                        <img
                          class="w-6"
                          src="@/assets/images/icons/profile.png"
                        />

                        <span
                          class="ml-2"
                          @click.stop="showCreditLimit(service)"
                          >{{ $t("customers.label.credit_limit") }}</span
                        >
                      </li>
                      <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      >
                        <feather-icon icon="SlashIcon" svgClasses="w-4 h-4" />
                        <span
                          @click="
                            cancelPlansPopup = true;
                            clientServiceId = service.clientServiceId;
                          "
                          class="ml-2"
                          >{{ $t("customers.label.cancel_plans") }}</span
                        >
                      </li>
                    </ul>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <template>
      <div class="con-content w-full">
        <vs-table
          v-if="selectedService"
          style="margin-left: 14px"
          class="service-order-tbl"
          :data="orderData"
        >
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th>{{ $t("customers.label.plan_name") }}</vs-th>
            <vs-th>{{ $t("customers.label.start_date") }}</vs-th>
            <vs-th>{{ $t("customers.label.ExpiryDate") }}</vs-th>
            <vs-th
              v-if="
                clientDetail &&
                clientDetail.billingInfo &&
                clientDetail.billingInfo.type === 'Prepaid'
              "
              >{{ $t("customers.label.NextRenewalDate") }}</vs-th
            >
            <vs-th
              v-if="
                clientDetail &&
                clientDetail.billingInfo &&
                clientDetail.billingInfo.type === 'Postpaid'
              "
              >{{ $t("customers.label.next_bill_date") }}</vs-th
            >
            <vs-th>{{ $t("customers.label.status") }}</vs-th>
            <vs-th>{{ $t("customers.label.action") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="order" v-for="(order, index) in data">
              <vs-td :data="order.planType">
                <template v-if="order.planType === 634">
                  <feather-icon
                    title="Base Plan"
                    icon="PackageIcon"
                    svgClasses="w-5 h-5 stroke-current red_icon"
                    class="icon_row postpaidIcon"
                  />
                </template>
                <template v-else-if="order.planType === 635">
                  <feather-icon
                    title="Addon Plan"
                    icon="PackageIcon"
                    svgClasses="w-5 h-5 stroke-current"
                    class="icon_row prepaidIcon"
                  />
                </template>
              </vs-td>
              <vs-td :data="order.planDescription">{{
                order.planDescription
              }}</vs-td>
              <vs-td :data="getDate(order.startDate)">{{
                getDate(order.startDate)
              }}</vs-td>
              <vs-td :data="getDate(order.endDate)">
                <span
                  v-if="
                    order.endDate &&
                    clientDetail &&
                    clientDetail.billingInfo &&
                    clientDetail.billingInfo.type === 'Prepaid'
                  "
                  >{{ getDate(order.endDate) }}</span
                >
                <span v-else>NA</span>
              </vs-td>
              <!-- Next bill date -->
              <vs-td
                v-if="
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type === 'Prepaid'
                "
              >
                <span v-if="order.endDate">{{
                  getRenewalDate(order.endDate)
                }}</span>
                <span v-else>NA</span>
              </vs-td>
              <vs-td
                v-if="
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type === 'Postpaid'
                "
              >
                <span v-if="order.planDescription === 'Shipping Charges'"
                  >NA</span
                >
                <span v-else-if="order.invoiceTilldate">{{
                  getRenewalDate(order.invoiceTilldate)
                }} {{
                  getTime(order.invoiceTilldate)
                }}</span>
                <span v-else>NA</span>
              </vs-td>
              <vs-td :data="order.status">
                <vs-chip
                  :color="getOrderStatusColor(order.status)"
                  class="product-order-status"
                  >{{ order.status }}
                </vs-chip>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img" v-if="order.status === 'ACTIVE'">
                  <feather-icon
                    v-if="order.isPrepaid === 'Y' && order.planType === 634"
                    title="Renewal Plan"
                    icon="RotateCwIcon"
                    @click.stop="
                      $emit('renewalPlan', order.clientServiceId, order)
                    "
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="icon_row"
                  />
                  <feather-icon
                    title="View"
                    icon="EyeIcon"
                    @click.stop="handleSelected(order)"
                    svgClasses="w-5 h-5 text-primary stroke-current"
                    class="icon_row"
                  />
                  <!-- <feather-icon
                    v-if="order.planType === 634"
                    title="Change Plan"
                    icon="EditIcon"
                    @click.stop="$emit('openChangePlan', order.clientServiceId, order)"
                    svgClasses="w-5 h-5 stroke-current orange_icon"
                    class="icon_row"
                  /> -->
                  <feather-icon
                    title="Cancel"
                    icon="XIcon"
                    v-if="order.planCode !== 'LFC'"
                    @click.stop="cancelSinglePlan(order)"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="icon_row"
                  />
                  <div v-if="order.planType === 634">
                    <vs-dropdown
                      v-if="order.status != 'TERMINATED'"
                      vs-custom-content
                      vs-trigger-click
                      class="cursor-pointer"
                    >
                      <div class="con-img">
                        <feather-icon
                          title="Add Plans"
                          icon="MoreHorizontalIcon"
                          svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          class="ml-2 icon_row"
                        />
                      </div>
                      <vs-dropdown-menu class="vx-navbar-dropdown">
                        <ul style="min-width: 13rem">
                          <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/suspend.svg"
                            />
                            <span
                              @click.stop="
                                $emit(
                                  'openChangePlan',
                                  order.clientServiceId,
                                  getOrdersData(order.clientServiceId),
                                  order.planTypeName
                                )
                              "
                              class="ml-2"
                              >{{ $t("customers.label.change_plan") }}</span
                            >
                          </li>
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                          >
                            <feather-icon
                              icon="SlashIcon"
                              svgClasses="w-4 h-4"
                            />
                            <span
                              @click="
                                cancelPlansPopup = true;
                                clientServiceId = order.clientServiceId;
                              "
                              class="ml-2"
                              >{{ $t("customers.label.cancel_plans") }}</span
                            >
                          </li> -->
                          <!-- <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      >
                        <feather-icon
                          icon="SmartphoneIcon"
                          svgClasses="w-4 h-4"
                        />
                        <span
                          @click="
                            addDevicePopup = true;
                            addDevice.clientServiceId = service.id;
                          "
                          class="ml-2"
                          >{{ $t("customers.label.add_device") }}</span
                        >
                      </li> -->
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/addplan.svg"
                            />
                            <span
                              @click="
                                addPlanPopup = true;
                                addPlanObj.clientServiceId = order.clientServiceId;
                              "
                              class="ml-2"
                              >{{ $t("customers.label.add_plans") }}</span
                            >
                          </li> -->
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/terminate.svg"
                            />
                            <span
                              @click="
                                addPlanPopup = true;
                                addPlanObj.clientServiceId =
                                  order.clientServiceId;
                              "
                              class="ml-2"
                              >{{ $t("customers.label.addons") }}</span
                            >
                          </li> -->
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/commandcenter.svg"
                            />
                            <span @click="" class="ml-2">{{
                              $t("customers.label.porting_out")
                            }}</span>
                          </li> -->
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                            v-if="
                              clientDetail &&
                              clientDetail.billingInfo &&
                              clientDetail.billingInfo.type === 'Prepaid'
                            "
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/retrack.svg"
                            />
                            <span @click="" class="ml-2">{{
                              $t("customers.label.prepaid_to_postpaid")
                            }}</span>
                          </li> -->
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                            v-if="
                              clientDetail &&
                              clientDetail.billingInfo &&
                              clientDetail.billingInfo.type === 'Postpaid'
                            "
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/addplan.svg"
                            />
                            <span @click="" class="ml-2">{{
                              $t("customers.label.postpaid_to_prepaid")
                            }}</span>
                          </li> -->
                          <!-- <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white view_editTable_btn"
                          >
                            <img
                              class="logo-img"
                              src="@/assets/images/icons/addplan.svg"
                            />
                            <span
                              @click.stop="
                                $emit(
                                  'swapDevice',
                                  order.clientServiceId,
                                  order
                                )
                              "
                              class="ml-2"
                              >{{ $t("customers.label.swap_sim") }}</span
                            >
                          </li> -->
                          <!-- <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        v-if="service.status != 'SUSPENDED'"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/suspend.svg"
                        />
                        <span
                          class="ml-2"
                          @click="
                            clientServiceId =order.clientServiceId;
                            suspendPlan();
                          "
                          >{{ $t("customers.label.suspend") }}</span
                        >
                      </li> -->
                          <!-- <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        v-else
                      >
                        <feather-icon icon="PlayIcon" svgClasses="w-4 h-4" />
                        <span
                          class="ml-2"
                          @click="
                            clientServiceId = order.clientServiceId;
                            reactivatePlan();
                          "
                          >{{ $t("customers.label.reactivate") }}</span
                        >
                      </li> -->
                          <!-- <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/terminate.svg"
                        />
                        <span
                          class="ml-2"
                          @click="
                            terminatePopup = true;
                            clientServiceId = order.clientServiceId;
                          "
                          >{{ $t("customers.label.terminate") }}</span
                        >
                      </li> -->
                          <!-- <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/commandcenter.svg"
                        />
                        <span
                          class="ml-2"
                          @click="
                            commandCenterPopup = true;
                            commandDevice.clientServiceId = order.clientServiceId;
                          "
                          >{{ $t("customers.label.command_center") }}</span
                        >
                      </li> -->
                          <!-- <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      >
                        <img
                          class="logo-img"
                          src="@/assets/images/icons/retrack.svg"
                        />
                        <span class="ml-2">{{
                          $t("customers.label.retrack")
                        }}</span>
                      </li> -->
                        </ul>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </template>
    <!-- provisioning_detail -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.provisioning_detail')"
        :active.sync="provisioningMessagePopup"
        class="popup-close"
      >
        <div class="vx-row w-full" v-if="sentMessage.request_type">
          <table class="table w-full table-bordered table-striped">
            <tr>
              <td>
                <b>{{ $t("customers.label.request_type") }}</b>
              </td>
              <td colspan="2">{{ sentMessage.request_type }}</td>
            </tr>
            <tr
              v-for="(key_, i) of Object.keys(sentMessage.clientInfo[0])"
              :key="i"
            >
              <td
                v-if="i == 0"
                :rowspan="Object.keys(sentMessage.clientInfo[0]).length"
              >
                <b>{{ $t("customers.label.client_info") }}</b>
              </td>
              <td>
                <b>{{ key_ }}</b>
              </td>
              <td>
                {{ sentMessage.clientInfo[0][key_] }}
              </td>
            </tr>
            <tr
              v-for="(key_, i) of Object.keys(sentMessage.serviceInfo[0])"
              :key="i"
            >
              <td
                v-if="i == 0"
                :rowspan="Object.keys(sentMessage.serviceInfo[0]).length"
              >
                <b>{{ $t("customers.label.service_info") }}</b>
              </td>
              <td>
                <b>{{ key_ }}</b>
              </td>
              <td>
                {{ sentMessage.serviceInfo[0][key_] }}
              </td>
            </tr>
            <tr
              v-for="(key_, i) of Object.keys(sentMessage.newDeviceInfo[0])"
              :key="i"
            >
              <td
                v-if="i == 0"
                :rowspan="Object.keys(sentMessage.newDeviceInfo[0]).length"
              >
                <b>{{ $t("customers.label.new_device_info") }}</b>
              </td>
              <td>
                <b>{{ key_ }}</b>
              </td>
              <td>
                {{ sentMessage.newDeviceInfo[0][key_] }}
              </td>
            </tr>
            <tr
              v-for="(key_, i) of Object.keys(sentMessage.TaskList[0])"
              :key="i"
            >
              <td
                v-if="i == 0"
                :rowspan="Object.keys(sentMessage.TaskList[0]).length"
              >
                <b>{{ $t("customers.label.task_list") }}</b>
              </td>
              <td>
                <b>{{ key_ }}</b>
              </td>
              <td>
                {{ sentMessage.TaskList[0][key_] }}
              </td>
            </tr>
            <tr
              v-for="(key_, i) of Object.keys(sentMessage.newOrderList[0])"
              :key="i"
            >
              <td
                v-if="i == 0"
                :rowspan="Object.keys(sentMessage.newOrderList[0]).length"
              >
                <b>{{ $t("customers.label.task_list") }}</b>
              </td>
              <td>
                <b>{{ key_ }}</b>
              </td>
              <td>
                {{ sentMessage.newOrderList[0][key_] }}
              </td>
            </tr>
            <tr v-if="sentMessage.responseMessage">
              <td>
                <b>{{ $t("customers.label.ResponseMessage") }}</b>
              </td>
              <td colspan="2">{{ sentMessage.responseMessage }}</td>
            </tr>
          </table>
        </div>
        <div class="center mb-2">
          <span class="ml-1 mr-1">
            <vs-button
              @click="provisioningMessagePopup = false"
              class="footerButton-next"
              style="top: 0px"
              >{{ $t("customers.label.close") }}</vs-button
            >
          </span>
        </div>
      </vs-popup>
    </div>
    <!-- client_service_detail -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.client_service_detail')"
        :active.sync="clientServiceDetailPopup"
        class="popup-close popup-big"
      >
        <div class="w-full">
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("customers.label.id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.parameter_name") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.parameter_value") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.status") }}</b>
                </td>
              </tr>
              <tr v-for="(Broadcaster, index) in clientDetailList" :key="index">
                <td>{{ Broadcaster.id }}</td>
                <td>{{ Broadcaster.paramName }}</td>
                <td>{{ Broadcaster.type }}</td>
                <td>{{ Broadcaster.status }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="w-full">
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <div style="width: 150px">
                    <b>{{ $t("customers.label.provisioning_detail") }}</b>
                  </div>
                </td>
                <td>
                  <b>{{ $t("customers.label.request_type") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.status") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.workflow_id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.task_id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.sent_message") }}</b>
                </td>
              </tr>
              <tr v-for="(Broadcaster, index) in provisioningList" :key="index">
                <td>{{ Broadcaster.id }}</td>
                <td>{{ Broadcaster.requestType }}</td>
                <td>
                  {{ Broadcaster.isProcessed == "Y" ? "Success" : "Failed" }}
                </td>
                <td>
                  <a
                    v-if="Broadcaster && Broadcaster.responseId"
                    @click="navigationLink(Broadcaster)"
                    style="cursor: pointer"
                  >
                    {{ Broadcaster.responseId }}
                  </a>
                </td>
                <td>{{ Broadcaster.taskId }}</td>
                <td>
                  <div>
                    <feather-icon
                      title="Swap"
                      icon="MailIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="ml-2"
                      @click="sendMessage(Broadcaster)"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="w-full">
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("customers.label.ScheduleOrder") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.order_id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.created_date") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.ScheduledDate") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.ContractPeriod") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.transaction_type") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.status") }}</b>
                </td>
              </tr>
              <tr
                v-for="(Broadcaster, index) in scheduleOrdersById"
                :key="index"
              >
                <td>{{ Broadcaster.Id }}</td>
                <td>{{ Broadcaster.orderId }}</td>
                <td>
                  {{
                    Broadcaster.createdDate
                      ? getDate(Broadcaster.createdDate)
                      : "-"
                  }}
                </td>
                <td>{{ getDate(Broadcaster.scheduledDate) }}</td>
                <td>{{ Broadcaster.contractPeriod }}</td>
                <td>{{ Broadcaster.transactionType }}</td>
                <td>{{ Broadcaster.status == "Y" ? "Success" : "Pending" }}</td>
              </tr>
            </table>
          </div>
        </div>
      </vs-popup>
    </div>
    <!-- client_slc_history -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.slc_state_history')"
        :active.sync="slcHistoryPopup"
        class="popup-close popup-big"
      >
        <div class="w-full">
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("customers.label.id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.created_date") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.created_time") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.event_id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.client_id") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.serial_number") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.previous_state") }}</b>
                </td>
                <td>
                  <b>{{ $t("customers.label.current_state") }}</b>
                </td>
              </tr>
              <tr v-for="(slc, index) in slcDataList" :key="index">
                <td>{{ slc.id }}</td>
                <td>{{ getSlcDate(slc.eventJson) }}</td>
                <td>{{ getSlcTime(slc.eventJson) }}</td>
                <td>{{ slc.eventId }}</td>
                <td>{{ slc.clientId }}</td>
                <td>{{ slc.serialNo }}</td>
                <td>{{ getSlcStatus(slc.previousState) }}</td>
                <td>{{ getSlcStatus(slc.currentState) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </vs-popup>
    </div>
    <!-- add_device -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.add_device')"
        :active.sync="addDevicePopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.entity_name")
                  }}<span class="required">*</span></small
                >
                <v-select
                  label="name"
                  v-model="addDevice.officeId"
                  :options="
                    deviceTemplate.officesData ? deviceTemplate.officesData : []
                  "
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(name) => name.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.sale_date")
                  }}<span class="required">*</span></small
                >
                <datepicker
                  :placeholder="$t('customers.label.SelectDate')"
                  v-model="addDevice.saleDate"
                  class="mb-2 font-semibold"
                />
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.serial_no")
                  }}<span class="required">*</span></small
                >
                <vue-simple-suggest
                  v-model="serialNumObj.serialNumber"
                  :list="itemList.serialNumbers"
                  @input="serialNumberCheck"
                  value-attribute="item"
                  display-attribute="item"
                  :filter-by-query="true"
                >
                  <!-- Filter by input text to only show the matching results -->
                </vue-simple-suggest>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.item")
                  }}<span class="required">*</span></small
                >
                <v-select
                  label="item"
                  v-model="serialNumObj.itemType"
                  :options="serialitemdetail"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(item) => item.item"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.discount")
                  }}<span class="required">*</span></small
                >
                <v-select
                  label="discountCode"
                  v-model="addDevice.discountId"
                  :options="
                    deviceTemplate.discountMasterDatas
                      ? deviceTemplate.discountMasterDatas
                      : []
                  "
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(item) => item.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                :label="$t('customers.label.total_price')"
                v-model="addDevice.unitPrice"
                class="w-full font-semibold mb-2 starlabel"
              />
            </div>
          </div>
          <div class="center mb-2">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addDeviceFunc"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- Add Plan-->
    <div class="centerx">
      <vs-popup
        button-close-hidden="true"
        classContent="popup-example"
        :title="$t('customers.label.add_plans')"
        :active.sync="addPlanPopup"
        class="popup-close popup-big"
      >
        <form>
          <div class="vx-row container mb-4">
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
            >
              <div class="header">
                <div class="details-header2 flex justify-between items-center">
                  <h2 class="text-white">
                    {{ $t("customers.label.AddPlan") }}
                  </h2>
                </div>
              </div>

              <div class="plans vx-card p-3">
                <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                  <!-- <div class="vx-col sm:w-full md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("customers.label.plan_list")
                        }}<span class="required">*</span></small
                      >
                      <v-select
                        label="name"
                        v-model="planObj.planId"
                        :options="planPacks"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        @input="callAddPlans(e)"
                        :reduce="(name) => name.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                    </div>
                  </div> -->
                  <div class="vx-col sm:w-full md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("customers.label.start_date")
                        }}<span class="required">*</span></small
                      >
                      <datepicker
                        :placeholder="$t('customers.label.SelectDate')"
                        v-model="planObj.startDate"
                        class="mb-2 font-semibold"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-for="(pricing, index) in PlanInfo"
                  :key="index"
                  class="mb-4"
                >
                  <PricingCard
                    :data="pricing"
                    :isAddon="true"
                    :contentData="contentData"
                    :selectedAddonProp="selectedAddon"
                    @planClicked="addonSelected"
                  />
                </div>
              </div>
            </div>
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
            >
              <div class="">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="header">
                      <div class="details-header2 flex items-center">
                        <h3 class="ml-3 text-white">
                          {{ $t("customers.label.Basket") }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-card p-2">
                  <div
                    class="card p-3"
                    v-for="(addon, index) in addonData"
                    :key="index"
                  >
                    <h2 class="card-title">{{ addon.planName }}</h2>
                    <div class="delete-icon" @click="deleteAddon(index)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                        />
                      </svg>
                    </div>
                    <div class="price-container">
                      <span class="old-price"
                        >{{
                          addonData.length && addonData[0].currencySymbol
                            ? addonData[0].currencySymbol
                            : ""
                        }}
                        {{ addon.price }}</span
                      >
                      <span class="current-price"
                        >{{
                          addonData.length && addonData[0].currencySymbol
                            ? addonData[0].currencySymbol
                            : ""
                        }}
                        {{ addon.finalPrice }}</span
                      >
                    </div>
                    <!-- <ul class="features">
                      <li class="feature-item">
                        <span class="checkmark"></span>
                        10GB EU roaming included
                      </li>
                      
                    </ul> -->
                  </div>

                  <div class="text-gray-700 font-semibold">
                    {{ $t("customers.label.TotalPrice") }}
                    {{
                      addonData.reduce((acc, item) => acc + item.finalPrice, 0)
                    }}
                    <span style="color: green"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="center mb-2">
            <span class="ml-1 mr-1">
              <vs-button
                @click="cancelAddPlan"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-1">
              <vs-button
                @click="addPlanFunc"
                class="footerButton-next"
                style="top: 0px"
                v-show="clientDetail.billingInfo.type !== 'Prepaid'"
                >{{ $t("customers.label.submit") }}</vs-button
              >
              <vs-button
                @click="handleSendLink"
                :disabled="
                  addonData.length === 0 ||
                  !(
                    paymentStatusData &&
                    (paymentStatusData.id === undefined ||
                      paymentStatusData.status === 'expired')
                  )
                "
                v-show="clientDetail.billingInfo.type === 'Prepaid'"
                v-if="
                  paymentStatusData.id === undefined ||
                  paymentStatusData.status === 'expired'
                "
                :loading="loading"
              >
                {{
                  $t(
                    "customers.label.Send_Link_to_Customer_to_Complete_Payment"
                  )
                }}
              </vs-button>
              <vs-button
                v-else
                v-show="clientDetail.billingInfo.type === 'Prepaid'"
                @click="handlePaymentStatus"
                :disabled="
                  !paymentStatusData.id ||
                  paymentStatusData.status === 'expired'
                "
                :loading="loading"
              >
                {{ $t("customers.label.CheckPaymentStatus") }}
              </vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- terminate -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.terminate')"
        :active.sync="terminatePopup"
        class="popup-close small-popup"
      >
        <form>
          <div class="vx-row">
            <h3 class="service-heading--large text-center">
              {{ $t("customers.label.Are_you_sure_you_want_to_terminate?") }}
            </h3>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="serviceTerminate"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <!-- Cancel Plans-->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.cancel_plans')"
        :active.sync="cancelPlansPopup"
        class="popup-close"
      >
        <div class="vx-row w-full">
          <vs-table
            :max-items="10"
            class="ml-2 w-full"
            pagination
            multiple
            :data="cancelPlanList"
            v-model="selectedCancelPlans"
          >
            <template slot="header">
              <h4 class="mb-2">
                {{ $t("customers.label.available_plans") }}
              </h4>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.item_code") }}</vs-th>
              <vs-th>{{ $t("customers.label.serial_no") }}</vs-th>
              <vs-th>{{ $t("customers.label.action") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="device"
                v-for="(device, index) in data"
              >
                <vs-td :data="device.itemCode">{{ device.orderId }}</vs-td>
                <vs-td :data="device.planCode">{{
                  device.planDescription
                }}</vs-td>
                <vs-td>
                  {{ device.contractPeriod }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="center mb-2">
          <span class="ml-1 mr-1">
            <vs-button
              @click="disconnectPlanPopup = true"
              class="footerButton-next"
              style="top: 0px"
              >{{ $t("customers.label.submit") }}</vs-button
            >
          </span>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('customers.label.disconnect_order')"
            :active.sync="disconnectPlanPopup"
            class="popup-close mid-popup"
          >
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full md:w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.reason")
                      }}<span class="required">*</span></small
                    >
                    <v-select
                      label="mCodeValue"
                      v-model="disconnectPlanObj.disconnectReason"
                      :options="disconnectData"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(name) => name.mCodeValue"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full md:w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.description")
                    }}</small>
                    <vs-textarea v-model="disconnectPlanObj.description" />
                  </div>
                </div>
              </div>
            </form>
            <div class="center mb-2">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="cancelPlans"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
              </span>
            </div>
          </vs-popup>
        </div>
      </vs-popup>
    </div>
    <!-- allowance -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.allowance')"
        :active.sync="allowancePopup"
        class="popup-close"
      >
        <table class="w-full table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ $t("customers.label.BalanceName") }}</th>
              <th>{{ $t("customers.label.Allowance") }}</th>
              <th>{{ $t("customers.label.Consumption") }}</th>
              <th>{{ $t("customers.label.AvailableBalance") }}</th>
              <th>{{ $t("customers.label.DaysLeft") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, k) in allowances.balances" :key="k">
              <td>
                {{ item.bucketName }}
              </td>
              <td>
                <span
                  v-if="
                    item.balance === '9999999999 SMS' ||
                    item.balance === '166666666 min 39 sec' ||
                    item.balance === '9999999999 Min'
                  "
                >
                  {{ $t("customers.label.Unlimited") }}
                </span>
                <span v-else>
                  {{ item.balance }}
                </span>
              </td>
              <td>
                <div>{{ calculateDifference(item) }}</div>
              </td>
              <td>
                <span
                  v-if="
                    item.availableBalance === '9999999999 SMS' ||
                    item.availableBalance === '166666666 min 39 sec' ||
                    item.availableBalance === '9999999999 Min'
                  "
                >
                  {{ $t("customers.label.Unlimited") }}
                </span>
                <span v-else>
                  {{ item.availableBalance }}
                </span>
              </td>
              <td>
                {{ daysLeft(item.leastExpiryTime) }}
                {{ $t("customers.label.days_left") }}
              </td>
            </tr>
          </tbody>
        </table>
      </vs-popup>
    </div>
    <!-- provisioning_commands -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.provisioning_commands')"
        :active.sync="commandCenterPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.command")
                  }}<span class="required">*</span></small
                >
                <v-select
                  label="commandName"
                  v-model="commandDevice.id"
                  :options="commandTemplate"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(commandName) => commandName.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </div>
            </div>
          </div>
          <div class="center mb-2">
            <span class="ml-1 mr-1">
              <vs-button class="footerButton-next" style="top: 0px">{{
                $t("customers.label.submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!-- credit_limit -->

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.updateCreditLimt')"
        :active.sync="updateCreditLimtPopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 mx-2">
            <vs-input
              :label="$t('customers.label.credit_limit')"
              v-model="creditLimit"
              class="w-full font-semibold"
            />
          </div>
          <div class="center mb-2">
            <span class="ml-1 mr-1">
              <vs-button
                class="footerButton-next"
                style="top: 0px"
                @click="updateCreditLimit"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="
          $t('customers.label.credit_limit') + ' ' + creditData.creditLimit
        "
        :active.sync="creditLimitPopup"
        class="popup-close"
      >
        <form>
          <div class="center">
            <CreditGauge
              :max="creditData.creditLimit"
              :available="creditData.availableCreditLimit"
            />
          </div>

          <div
            class="center mb-2"
            v-if="
              userType == 'Super user' ||
              permissionList.permissions.includes('UPDATE_CLIENTCREDITLIMIT')
            "
          >
            <span class="ml-1 mr-1">
              <vs-button
                v-if="
                  creditLimitStatus &&
                  creditLimitStatus[0] &&
                  creditLimitStatus[0].status &&
                  creditLimitStatus[0].status === 4
                "
                class="footerButton-next"
                style="top: 0px; width: 250px"
                @click="
                  creditLimit = creditData.creditLimit;
                  updateCreditLimtPopup = true;
                "
              >
                {{ $t("customers.label.updateCreditLimt") }}
              </vs-button>

              <vs-button
                v-else-if="
                  creditLimitStatus &&
                  creditLimitStatus[0] &&
                  creditLimitStatus[0].status &&
                  creditLimitStatus[0].status === 2
                "
                class="footerButton-next"
                style="top: 0px; width: 300px"
                disabled
              >
                {{ $t("customers.label.PendingForApproval") }}
              </vs-button>
              <vs-button
                v-else
                class="footerButton-next"
                style="top: 0px; width: 250px"
                @click="
                  creditLimit = creditData.creditLimit;
                  updateCreditLimtPopup = true;
                "
              >
                {{ $t("customers.label.updateCreditLimt") }}
              </vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Actions from "./Actions.vue";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import PricingCard from "./../../customerActivation/PlanInfoCardConponent.vue";
import { NGB_CONDUCTOR } from "@/http/index";
import CreditGauge from "@/components/CreditGauge.vue";

const planChangeEmpty = {
  billAlign: false,
  planCode: "",
  Newplanprepaid: "",
  clientServiceId: "",
  clientId: "",
  isNewplan: false,
  oldplanId: "",
  oldplanprepaid: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  start_date: moment().format("DD MMMM YYYY"),
  contractPeriod: 2,
  paytermCode: "",
  planPoId: "",
  dealPoId: "",
  changePlanDetail: "",
  disconnectionDate: moment().format("DD MMMM YYYY"),
  disconnectReason: "Not Interested",
};
const addDeviceEmpty = {
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  chargeCode: "",
  clientServiceId: "",
  discountId: 1,
  isPairing: "N",
  itemId: "",
  officeId: "",
  quantity: "1",
  saleDate: moment().format("DD MMMM YYYY"),
  saleType: "NEWSALE",
  serialNumber: [],
  totalPrice: "",
  unitPrice: "",
};
const serialNoEmpty = {
  serialNumber: "",
  status: "allocated",
  saleType: "NEWSALE",
  itemMasterId: "",
  isNewHw: "Y",
  itemType: "",
};
const serialNumEmpty = {
  serialNumber: "",
  status: "allocated",
  saleType: "NEWSALE",
  itemMasterId: "",
  clientId: "",
  orderId: "",
  isNewHw: "Y",
  itemType: "",
};
const addPlanEmpty = {
  id: "",
  planCode: "",
  planDescription: "",
  planPoId: "",
  dealPoId: "",
  paytermCode: "",
  contractPeriodId: 1,
  clientServiceId: "",
  billAlign: true,
  clientId: "",
  locale: "en",
  dateFormat: "yyyy-MM-dd HH:mm:ss",
  start_date: "",
  isNewplan: true,
};
const commandDeviceEmpty = {
  locale: "en",
  officeId: "",
  clientServiceId: "",
  clientId: "",
  id: "",
};
export default {
  data() {
    return {
      orderData: null,
      loading: false,
      basketData: {},
      addonData: [],
      contentData: [],
      selectedAddon: "",
      selectedService: false,
      descriptionItems: [5, 10, 15],
      clientServiceDetailPopup: false,
      clientServiceId: "",
      provisioningMessagePopup: false,
      cancelPlansPopup: false,
      addPlanPopup: false,
      slcHistoryPopup: false,
      terminatePopup: false,
      addDevicePopup: false,
      creditLimitPopup: false,
      updateCreditLimtPopup: false,
      creditLimit: "",
      selectedCancelPlans: [],
      serialitemdetail: [],
      disconnectPlanPopup: false,
      commandCenterPopup: false,
      allowancePopup: false,
      commandDevice: { ...commandDeviceEmpty },
      disconnectPlanObj: {
        disconnectReason: "",
        description: "",
      },
      addDevice: { ...addDeviceEmpty },
      serialNumObj: { ...serialNoEmpty },
      sentMessage: {},
      selected: "",
      suspensionPayload: {
        clientId: "",
        dateFormat: "dd MMMM yyyy",
        fromNGB: true,
        locale: "en",
        suspensionDate: moment().format("DD MMMM YYYY"),
        suspensionReason: "Not Intersted",
      },
      reactivationPayload: {
        clientId: "",
        dateFormat: "dd MMMM yyyy",
        fromNGB: true,
        locale: "en",
        reactivationDate: moment().format("DD MMMM YYYY"),
        reactivationReason: "Not Intersted",
      },
      changePlan: { ...planChangeEmpty },
      addPlanObj: { ...addPlanEmpty },
      planObj: {
        planId: "",
        selectedPlans: [],
        startDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      msisdnNo: "",
    };
  },
  computed: {
    ...mapGetters({ userType: "auth/userType" }),

    ...mapState({
      externalData: (state) => state.customer.externalData,
      permissionList: (state) => state.auth.user,
      PlanInfo: (state) => state.customerActivationNew.planData,
      allowances: (state) => state.customerOrder.allowanceList,
      clientDetail: (state) => state.customer.clientDetailData,
      clientDetailList: (state) => state.customer.clientDetails,
      provisioningList: (state) => state.customer.provisioningList,
      deviceTemplate: (state) => state.customer.deviceTemplate,
      itemList: (state) => state.customerActivation.itemList,
      itemDetail: (state) => state.customerActivation.itemDetail,
      formattedDate: (state) => state.settings.selectedDateFormat,
      planPacks: (state) => state.customer.planPacks,
      saleTemplateList: (state) => state.customerActivation.saleTemplateList,
      contractData: (state) => state.customerActivation.contractData,
      cancelPlanList: (state) => state.customer.cancelPlanList,
      disconnectData: (state) => state.customerOrder.disconnectData,
      commandTemplate: (state) => state.customer.commandTemplate,
      paymentStatusData: (state) =>
        state.customerActivationNew.paymentStatusData,
      creditData: (state) => state.customer.creditData,
      slcDataList: (state) => state.customer.slcDataList,
      creditLimitStatus: (state) => state.customer.creditLimitStatus,
      scheduleOrdersById: (state) => state.customer.scheduleOrdersById,
    }),
    accountStatus() {
      if (!this.externalData || !this.externalData.subsInfo) return [0];
      return this.externalData.subsInfo.map((x) => x.tempBlocked);
    },

    serviceOveriewDetails() {
      if (!this.clientDetail) {
      return [];
    }

    if (!this.clientDetail.services || !Array.isArray(this.clientDetail.services)) {
      return [];
    }

    if (this.clientDetail.services.length === 0) {
      return [];
    }

    const result = this.clientDetail.services.map((clientService) => {
      const devices = clientService.devices || [];
      
      const matchedItems = devices.filter(
        (item) => item.clientServiceId === clientService.id
      );
      
      let imsi = null;
      let msisdn = null;
      
      matchedItems.forEach((item) => {
        if (item.itemCode === "IMSI") {
          imsi = item.serialNo;
        } else if (item.itemCode === "MSISDN") {
          msisdn = item.serialNo;
          this.msisdnNo = item.serialNo;
        }
      });
      const plans = clientService.plans || [];
      
      const orderDetails = plans.filter(
        (item) => item.clientServiceId === clientService.id
      );
      
      if (!orderDetails.length) {
        return {
          mobileNo: {
            imsi: imsi || 'N/A',
            msisdn: msisdn || 'N/A',
          },
          spendCap: clientService.sepndCap || 0,
          salesMotion: clientService.salesMotion || 'N/A',
          startDate: "NA",
          status: clientService.status || "INACTIVE",
          id: clientService.id || "",
          serviceId: clientService.serviceId || "",
          clientServiceId: clientService.id || "",
        };
      }

      const endDate = this.calculateEndDate(orderDetails);
      
      return {
        mobileNo: {
          imsi: imsi || 'N/A',
          msisdn: msisdn || 'N/A',
        },
        spendCap: clientService.sepndCap || 0,
        salesMotion: clientService.salesMotion || 'N/A',
        planName: orderDetails[0].planCode || "",
        startDate: orderDetails[0].startDate || "NA",
        endDate: endDate || "NA",
        price: orderDetails[0].price || 0,
        status: clientService.status || "INACTIVE",
        id: clientService.id || "",
        serviceId: clientService.serviceId || "",
        clientServiceId: clientService.id || "",
      };
    });
    return result;
    },
  },
  components: {
    Actions,
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    PricingCard,
    CreditGauge,
  },
  methods: {
    async getServiceDetails() {
      await this.$store.dispatch("customer/getExternalAction", this.msisdnNo);
    },
    navigationLink(data) {
      window.open(NGB_CONDUCTOR + `execution/${data.responseId}`);
    },
    getTime(time) {
      const t = new Date(time);
      return moment(t, "HH:mm:ss").format("HH:mm:ss");
    },
    getSlcTime(data) {
      try {
        const parsedData = JSON.parse(data);
        return this.getTime(parsedData.eventJson.icpEvrInfo.genTime);
      } catch (error) {
        return "-";
      }
    },
    getSlcDate(data) {
      try {
        const parsedData = JSON.parse(data);
        return this.getDate(parsedData.eventJson.icpEvrInfo.genTime);
      } catch (error) {
        return "-";
      }
    },
    onClickTerminate(service){
      this.clientServiceId = service.id;
      this.terminatePopup = true;
    },
    async updateAccountStatus() {
      try {
        const payload = {
          id: this.msisdnNo,
          data: {
            cosId: this.externalData.subsInfo[0].cosId,
            valDate: this.externalData.subsInfo[0].validityDate,
            slcState: this.externalData.subsInfo[0].slcState || 2,
            tempBlock: this.externalData.subsInfo[0].tempBlocked ? 0 : 1,
          },
        };
        await this.$store.dispatch("customer/updateExternalAction", payload);
        this.getServiceDetails();
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Account Updated Successfully!",
          type: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: error.message,
          type: "error",
        });
      }
    },
    showCreditLimit(service) {
      this.creditLimitPopup = true;
      this.clientServiceId = service.serviceId;
      this.$store.dispatch(
        "customer/setCreditLimit",
        "91" + this.clientDetail.hwSerialNumber
      );
    },
    async updateCreditLimit() {
      const data = {
        id: this.$route.params.id,
        data: {
          mode: "set",
          // reference: "Invoice",
          // referenceId: "221",
          amount: this.creditLimit,
          currencyId:
            this.clientDetail.financialInfo.clientCreditLimitDatum.resourceId,
          currencysymbol: this.clientDetail.billingInfo.currencySymbol,
          serviceId: this.clientServiceId,
          msisdn: this.clientDetail.hwSerialNumber,
          currency: this.clientDetail.billingInfo.currencyCode,
          availableCreditLimit: this.creditLimit,
        },
      };
      try {
        const resp = await this.$store.dispatch(
          "customer/updateCreditLimitAction",
          data
        );

        this.$store.dispatch(
          "customer/setCreditLimit",
          "91" + this.clientDetail.hwSerialNumber
        );
        const msg = resp.data.description || "";
        if (resp.data.errorCode == 2002) {
          const failedString = resp.data.exRes;
          const match = failedString.match(/Failed\s*-\s*(.+)$/);
          const cleanErrorMessage = match ? match[1].trim() : "";
          this.$swal({
            title: "Error",
            icon: "error",
            text: cleanErrorMessage ? cleanErrorMessage : msg,
            type: "error",
          });
        } else {
          this.updateCreditLimtPopup = false;
          this.creditLimitPopup = false;
          this.checkCreditLimitStatusMethod();
          if (!msg) {
            if (resp.data.resourceId)
              await this.$swal({
                title: "Success",
                icon: "success",
                text: "Request sent for approval.",
                type: "success",
              });
          } else
            await this.$swal({
              title: "Success",
              icon: "success",
              text: msg.toUpperCase(),
              type: "success",
            });
        }
      } catch (error) {
        this.updateCreditLimtPopup = false;
        this.creditLimitPopup = false;
        this.$swal({
          title: "Error",
          icon: "error",
          text: error.message,
          type: "error",
        });
      }

      // this.getClient();
    },
    async handleSendLink() {
      let payload = {
        amount: {
          currency: this.clientDetail.billingInfo.currencyCode,
          value: Math.round(
            this.addonData.reduce((acc, item) => acc + item.finalPrice, 0) * 100
          ),
        },
        description: "Test",
        countryCode: "GB",
        shopperLocale: "en-GB",
        email: this.clientDetail.personalInfo.email,
        pkgName: this.addonData[0].planName,
        subsName: this.clientDetail.personalInfo.displayName,
      };
      try {
        this.loading = true;
        await this.$store.dispatch(
          "customerActivationNew/sendLinkAction",
          payload
        );
        this.addPlanPopup = false;
        await this.$swal({
          title: "info",
          icon: "info",
          text: "Payment Link Successfully Sent.",
          type: "info",
        });
        this.addPlanPopup = true;
      } catch (error) {
        this.$swal({
          title: "error",
          icon: "error",
          text: "Not able to send payment link! Try again later.",
          type: "error",
        });
      }
      this.loading = false;
    },
    async handlePaymentStatus() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "customerActivationNew/checkPaymentStatus",
          this.paymentStatusData.id
        );
        this.loading = false;
        if (this.paymentStatusData.status === "completed") {
          // this.$swal({
          //   title: "Success",
          //   icon: "success",
          //   text: "Payment Successful!",
          //   type: "success",
          // });
          const payload = {
            paymentCode: 728,
            amountPaid: (this.paymentStatusData.amount.value / 100)
              .toFixed(2)
              .toString(),
            receiptNo: this.paymentStatusData.reference,
            remarks: "Online Payment",
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            paymentDate: moment().format("DD MMMM YYYY"),
            isSubscriptionPayment: false,
          };
          await this.$store.dispatch("customerActivation/afterPayments", {
            id: this.$route.params.id,
            data: payload,
          });
          this.addPlanFunc();
        } else if (this.paymentStatusData.status === "active") {
          this.addPlanPopup = false;
          await this.$swal({
            title: "info",
            icon: "info",
            text: "Payment is pending!",
            type: "info",
          });
          this.addPlanPopup = true;
        } else if (this.paymentStatusData.status === "expired") {
          this.addPlanPopup = false;
          await this.$swal({
            title: "Expired",
            icon: "warning",
            text: "Payment Link Expired! Try Again.",
            type: "warning",
          });
        }
        this.$store.dispatch("customerActivationNew/clearPaymentData");
        this.addPlanPopup = true;
      } catch (error) {
        console.log(error, "error");
      }
    },
    async reactivateService(id) {
      this.$swal
        .fire({
          title: "Promise to Pay",
          text: "This is a temporary reactivation. The service will be partially suspended by end of day unless the customer clears the outstanding due amount.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          customClass: {
            content: "center",
            container: "my-swal-container",
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.$store.dispatch("customer/reactivateServiceAction", {
                id: id,
                data: { clientId: this.$route.params.id },
              });
              await this.$swal({
                title: "Success",
                icon: "success",
                text: "Reactivated Successfully!",
                type: "success",
              });
              this.getClient();
            } catch (error) {
              throw Error(
                error.message ||
                  `Api failed with status code: ${error.message.httpStatusCode}`
              );
            }
          }
        });
    },
    addonSelected(plan, data, content, p, sel) {
      this.selectedAddon = sel;

      const planData = {
        ...content,
        ...plan,
        planName: data.planCode,
        currencySymbol: data.symbol,
      };
      this.addonData = [planData];
      this.planObj.selectedPlans = this.saleTemplateList.filter(
        (item) => item.id === data.id
      );
    },
    toggleSelection(service) {
      if (this.selectedService) {
        this.getOrdersData(service.id);
      } else {
        this.selectedService = false;
      }
    },
    calculateDifference(bucket) {
      const parseValue = (value) => {
        const stringValue = String(value);
        const unit = stringValue.replace(/[\d.]/g, "");
        const amount = parseFloat(stringValue.replace(unit, ""));
        return { amount, unit };
      };
      const balanceParsed = parseValue(bucket.balance);
      const availableBalanceParsed = parseValue(bucket.availableBalance);
      if (balanceParsed.unit === availableBalanceParsed.unit) {
        const difference = balanceParsed.amount - availableBalanceParsed.amount;
        return `${difference} ${balanceParsed.unit}`;
      }
      return "Units mismatch";
    },
    daysLeft(date) {
      const expiryDate = moment(date, "YYYYMMDD HH:mm:ss");
      const currentDate = moment();
      const diffInDays = expiryDate.diff(currentDate, "days");
      return diffInDays;
    },
    calculateEndDate(orderDetails) {
      const startDate = moment(this.formatDate(orderDetails[0].startDate));
      const contractPeriod = orderDetails[0].contractPeriod;
      let endDate;
      if (contractPeriod.includes("Month")) {
        const months = parseInt(contractPeriod);
        endDate = startDate.clone().add(months, "months");
      } else if (contractPeriod.includes("Year")) {
        const years = parseInt(contractPeriod);
        endDate = startDate.clone().add(years, "years");
      } else {
        // Default to 1 month if contract period is not recognized
        endDate = startDate.clone().add(1, "month");
      }
      return endDate.format("DD-MMMM-YYYY");
    },
    formatDate(dateArray) {
      const [year, month, day] = dateArray;
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
    getDate(date) {
      if (typeof date == "object") {
        const dateFormat = new Date(date[0], date[1] - 1, date[2]);
        date = dateFormat.toLocaleDateString("en-US");
      }
      return moment(date).format(this.formattedDate);
    },
    getRenewalDate(date) {
      if (typeof date == "object") {
        const dateFormat = new Date(date[0], date[1] - 1, date[2]);
        date = dateFormat.toLocaleDateString("en-US");
      }
      return moment(date).add(1, "day").format(this.formattedDate);
    },
    async suspendPlan() {
      try {
        this.suspensionPayload.clientId = this.$route.params.id;
        await this.$store.dispatch("customer/suspendPlanAction", {
          id: this.clientServiceId,
          data: this.suspensionPayload,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Service Suspended Successfully!",
          type: "success",
        });
        this.getClient();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async reactivatePlan() {
      try {
        this.reactivationPayload.clientId = this.$route.params.id;
        await this.$store.dispatch("customer/activatePlanAction", {
          id: this.clientServiceId,
          data: this.reactivationPayload,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Service Reactivated Successfully!",
          type: "success",
        });
        this.getClient();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancelSinglePlan(plan) {
      this.$store.dispatch("customerOrder/getDisconnectPlans");
      this.selectedCancelPlans = [plan];
      this.disconnectPlanPopup = true;
    },
    async getOrderDisconnect() {
      try {
        this.$store.dispatch("customerOrder/getDisconnectPlans");
      } catch (error) {
        console.log(
          "something went to wrong while retrieving entity by id:",
          error
        );
      }
    },
    async refreshServiceData() {
    try {
      await this.getClient();
      this.$forceUpdate();
    } catch (error) {
      console.error('Error refreshing service data:', error);
    }
  },
    async getClient() {
      try {
        await this.$store.dispatch(
          "customer/setClientDetailData",
          this.$route.params.id
        );
      
      if (this.clientDetail && this.clientDetail.accountInfo) {
        this.loc = this.clientDetail.accountInfo.office.id;
      }
        await this.$store.dispatch(
          "customerMoreInfo/getAllClientDocumentsAction",
          this.$route.params.id
        );
        return this.clientDetail;
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getDeviceData(id) {
      let tempArray = [];
      for (let temp of this.clientDetail.oneTimeSaleData) {
        if (temp.clientServiceId == id) {
          tempArray.push(temp);
        }
      }
      return tempArray;
    },
    async getPlanPacks() {
      await this.$store.dispatch("customer/getPlanPackAction");
    },
    handleSelected(item) {
      this.$router.push({
        name: "View Order",
        params: { id: this.$route.params.id, orderId: item.orderId },
      });
    },
    viewClientService(service) {
      const payload = {
        clientId: this.$route.params.id,
        serviceId: service.id,
      };
      this.$store.dispatch(
        "customer/getClientServiceDetailsQueryAction",
        payload
      );
      this.$store.dispatch(
        "customer/getScheduleOrdersByIdAction",
        this.$route.params.id
      );
      this.$store.dispatch("customer/getProvisioningDetails", service.id);

      this.clientServiceDetailPopup = true;
    },
    viewSlcHistory() {
      this.slcHistoryPopup = true;
    },
    getOrderStatusColor(status) {
      if (status === "Inactive") return "dark";
      if (status === "New") return "warning";
      if (status === "DRAFT") return "danger";
      if (status === "TERMINATED") return "danger";
      if (status === "DISCONNECTED") return "danger";
      if (status === "SUSPENDED") return "dark";
      if (status === "Pending") return "orange";
      if (status === "PROCESSING") return "orange";
      return "success";
    },
    getOrdersData(id) {
      let tempArray = [];
      for (let temp of this.clientDetail.services[0].plans) {
        if (temp.clientServiceId == id) {
          tempArray.push(temp);
        }
      }
      this.orderData = tempArray;
      this.orderData.sort((a, b) => {
        if (a.planType === 634 && b.planType !== 634) return -1;
        if (a.planType !== 634 && b.planType === 634) return 1;
        return 0;
      });

      return this.orderData;
    },
    sendMessage(Broadcaster) {
      this.provisioningMessagePopup = true;
      this.sentMessage = Broadcaster.sentMessage
        ? JSON.parse(Broadcaster.sentMessage)
        : {};
      if (!this.sentMessage.newDeviceInfo) {
        this.sentMessage.newDeviceInfo = [{}];
      }
      if (!this.sentMessage.serviceInfo) this.sentMessage.serviceInfo = [{}];
      if (!this.sentMessage.TaskList) this.sentMessage.TaskList = [{}];
      if (!this.sentMessage.newOrderList) this.sentMessage.newOrderList = [{}];
      if (Broadcaster.responseMessage)
        this.sentMessage.responseMessage = Broadcaster.responseMessage;
    },
    async serialNumberCheck() {
      await this.$store.dispatch("customerActivation/setItemDetailsByQuery", {
        loc: this.clientDetail.accountInfo.office.id,
        sl: this.serialNumObj.serialNumber,
      });
      await this.$store.dispatch("customerActivation/setItemDetails", {
        loc: this.clientDetail.accountInfo.office.id,
        sl: this.serialNumObj.serialNumber,
      });
      this.addDevice.unitPrice = this.itemDetail.unitPrice;
      this.addDevice.totalPrice = this.itemDetail.unitPrice;
      this.addDevice.itemId = this.itemDetail.itemMasterId;
      this.addDevice.chargeCode = this.itemDetail.chargeCode;
      this.addDevice.isPairing = this.itemDetail.isPairing;
      this.serialNumObj.itemType = this.itemDetail.itemCode;
      this.serialNumObj.itemMasterId = this.itemDetail.itemMasterId;
      // this.serialNumObj.orderId = this.$route.params.id;
      // this.serialNumObj.clientId = this.$route.params.id;
    },
    async addDeviceFunc() {
      this.addDevice.serialNumber = [];
      this.addDevice.serialNumber.push(this.serialNumObj);
      if (
        !this.serialNumObj.serialNumber ||
        !this.addDevice.discountId ||
        !this.addDevice.officeId ||
        !this.addDevice.saleDate
      ) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          await this.$store.dispatch("customer/addDeviceAction", {
            id: this.$route.params.id,
            data: this.addDevice,
          });
          this.addDevicePopup = false;
          this.addDevice = { ...addDeviceEmpty };
          this.serialNumObj = { ...serialNumEmpty };
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Device Added Successfully!",
            type: "success",
          });
          this.getClient();
        } catch (e) {
          this.errorMessage = (
            e.message.errors[0].defaultUserMessage || ""
          ).replace("The parameter", "");
          this.warningPopup = true;
          this.errors = e.message.errors;
        }
      }
    },
    cancelAddPlan() {
      this.addPlanPopup = false;
      this.planObj = {
        planId: "",
        selectedPlans: [],
        startDate: moment().format("DD MMMM YYYY"),
      };
      this.selectedAddon = "";
      this.addonData = [];
      this.getPlanInfoMethod("");
    },
    async addPlanFunc() {
      let payload = { plans: [] };
      for (let temp of this.planObj.selectedPlans) {
        let planData = {
          planId: temp.id,
          paytermCode: temp.chargeCycle,
          contractPeriodId: temp.contractPeriodId || null,
          clientServiceId: this.clientDetail.services[0].id || "",
          billAlign: true,
          clientId: this.$route.params.id,
          locale: "en",
          dateFormat: "yyyy-MM-dd HH:mm:ss",
          start_date: this.planObj.startDate,
          isNewplan: true,
          channel: this.clientDetail.services[0].salesMotion || "POS",
        };
        payload.plans.push(planData);
      }
      try {
        await this.$store.dispatch("customer/addPlanCatalogueAction", {
          id: this.$route.params.id,
          data: payload,
        });
        this.$store.dispatch("customerActivationNew/clearPaymentData");
        this.addPlanPopup = false;
        this.selectedAddon = "";
        this.planObj = {
          planId: "",
          selectedPlans: [],
          startDate: moment().format("DD MMMM YYYY"),
        };
        this.addonData = [];
        this.getPlanInfoMethod("");
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Plan Added Successfully!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.warningText = "";
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getDeviceTemplate() {
      await this.$store.dispatch(
        "customer/deviceTemplateAction",
        this.$route.params.id
      );
    },
    async viewAllowanceData() {
      if (
        (this.clientDetail.externalId !== "none" &&
          this.clientDetail.externalId !== "") ||
        (this.clientDetail.services[0].serviceAccountNo !== "none" &&
          this.clientDetail.services[0].serviceAccountNo !== "")
      ) {
        const payload = {
          customerId: this.clientDetail.externalId,
          accountNo: this.clientDetail.services[0].serviceAccountNo,
          serviceNumber: this.getProvisionalNumber("MSISDN"),
          type: this.clientDetail.billingInfo.type.toLowerCase(),
        };
        await this.$store.dispatch("customerOrder/fetchAllowance", payload);
        if (this.allowances.balances && this.allowances.balances.length)
          this.allowancePopup = true;
        else
          this.$swal({
            title: "No Data",
            icon: "warning",
            text: "No data available to show",
            type: "warning",
          });
      } else {
        this.$swal({
          title: "error",
          icon: "error",
          text: "External ID or Account Number is Undefined!",
          type: "error",
        });
      }
    },

    getProvisionalNumber(itemCode) {
      const item = this.clientDetail.services[0].devices.find(
        (item) => item.itemCode === itemCode
      );
      return item ? item.provserialnumber : "";
    },
    async callAddPlans() {
      this.getPlanInfoMethod("AddonPlan");
      try {
        await this.$store.dispatch(
          "customerActivation/getSalesTemplateList",
          this.planObj.planId
        );
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async cancelPlans() {
      this.disconnectPlanPopup = false;
      let planArray = [];
      for (let temp of this.selectedCancelPlans) {
        planArray = [
          ...planArray,
          {
            id: temp.orderId,
            planDescription: temp.planDescription,
            orderNo: temp.orderNo,
            planPoId: temp.planPoId || "0",
            dealPoId: temp.dealPoId || "0",
            clientServiceId: this.clientServiceId,
            disconnectReason: this.disconnectPlanObj.disconnectReason,
            description: this.disconnectPlanObj.description,
            locale: "en",
            dateFormat: "yyyy-MM-dd HH:mm:ss",
            disconnectionDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
        ];
      }
      try {
        let payload = { plans: planArray };
        await this.$store.dispatch("customer/cancelPlansAction", {
          id: this.$route.params.id,
          data: payload,
        });
        this.disconnectPlanObj = {
          disconnectReason: "",
          description: "",
        };
        this.cancelPlansPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Plans Cancelled Successfully!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.warningText = "";
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async planSelected() {
      this.selectedPlan = this.saleTemplateList.find(
        (el) => el.id === this.fetchedServiceInfo.planId
      );
      this.planData[0].planCode = this.selectedPlan.id;
      this.planData[0].planName = this.selectedPlan.planCode;
      this.planData[0].planPoId = this.selectedPlan.planPoId;
      this.planData[0].dealPoId = this.selectedPlan.dealPoId;
      await this.$store.dispatch(
        "customerActivation/setContractDetails",
        this.planData[0].planCode
      );
      if (this.contractData.contractPeriod) {
        let tempList = [];
        for (let temp of this.contractData.subscriptiondata) {
          if (temp.Contractdata == this.contractData.contractPeriod)
            tempList.push(temp);
        }
        this.contractData.subscriptiondata = tempList;
      }
    },
    async serviceTerminate() {
      await this.$store.dispatch("customer/serviceTerminateAction", {
        id: this.clientServiceId,
        data: { clientId: this.$route.params.id },
      });
      this.terminatePopup = false;
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Service Terminated Successfully!",
        type: "success",
      });
      this.getClient();
    },
    async getSlcDataMethod() {
      await this.$store.dispatch(
        "customer/getSlcDataAction",
        this.$route.params.id
      );
    },
    async checkCreditLimitStatusMethod() {
      try {
        await this.$store.dispatch(
          "customer/checkCreditLimitStatusAction",
          this.$route.params.id
        );
      } catch (error) {
        //
      }
    },
    // async orderDisconnects() {
    //   try {
    //     await this.$store.dispatch("customer/setOrderDisconnects");
    //   } catch (error) {
    //     throw Error(
    //       error.message ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
    async getCommandTemplate() {
      await this.$store.dispatch(
        "customer/provisioningCommandTemplate",
        this.$route.params.id
      );
    },
    deleteAddon(index) {
      this.addonData.splice(index, 1);
      this.selectedAddon = "";
    },
    async getPlanInfoMethod(type) {
      const data = {
        locale: "en",
        plantype: type,
        isprepaid: this.clientDetail.billingInfo.type === "Prepaid" ? "Y" : "N",
        salesChannel: "POS",
        accessibleOnly: "Y",
      };

      const processedIds = new Set();
      try {
        await this.$store
          .dispatch("customerActivationNew/fetchPlanInfoAction", data)
          .then((res) => {
            const pageItems = res.data.pageItems;
            for (const x of pageItems) {
              if (processedIds.has(x.id)) continue;
              processedIds.add(x.id);
              pageItems.forEach((item) => {
                this.contentData.push(item.documentData);
              });
            }
          });
      } catch (error) {
        throw Error();
        //
      }
    },
    getSlcStatus(id) {
      const slcStatusMap = {
        1: "IDLE",
        2: "ACTIVE",
        3: "AWAIT_ACTIVATION",
        4: "AWAIT_FIRST_ACTIVATION",
        5: "SUSPENDED_S1",
        6: "DISABLED_S2",
        7: "RETIRED_S3",
        8: "EXPIRED_S4",
        9: "FRAUD_LOCKOUT",
        10: "PENDING",
        11: "BARRED",
        12: "DEACTIVATED",
        13: "Active-Grace",
        14: "Grace-Period-1",
        15: "Grace-Period-2",
      };

      return slcStatusMap[id] || "-";
    },
  },
  watch: {
    clientDetail: {
      handler(newVal) {
      if (!newVal) {
        console.log('clientDetail is null');
        return;
      }
      
      this.$nextTick(() => {
        if (this.serviceOveriewDetails && this.serviceOveriewDetails.length) {
          this.selectedService = true;
          this.toggleSelection(this.serviceOveriewDetails[0]);
        } else {
          console.log('No service overview details available');
          this.selectedService = false;
        }
      });
    },
    deep: true,
    immediate: true,
    },
    addPlanPopup(newval) {
      if (newval) {
        this.getPlanPacks();
      }
    },
    addDevicePopup(newval) {
      if (newval) {
        this.getDeviceTemplate();
        this.addDevice.officeId = this.clientDetail.accountInfo.office.id;
        this.serialNumObj = { ...serialNumEmpty };
      }
    },
    cancelPlansPopup(newval) {
      if (newval) {
        this.$store.dispatch("customer/getCancelPlans", {
          clientId: this.$route.params.id,
          serviceId: this.clientServiceId,
        });
        // this.$store.dispatch("customer/getDisconnectPlans");
      }
    },
    commandCenterPopup(newval) {
      if (newval) {
        this.getCommandTemplate();
        this.commandDevice.clientServiceId = this.clientDetail.services[0].id;
      }
    },
  },
  async mounted() {
    try{
    await this.getClient();
    this.getOrderDisconnect();
    if (this.msisdnNo) {
      await this.getServiceDetails();
    }
    await this.getSlcDataMethod();
    this.checkCreditLimitStatusMethod();
    this.$nextTick(() => {  
      if (this.serviceOveriewDetails && this.serviceOveriewDetails.length) {
        this.selectedService = true;
        this.toggleSelection(this.serviceOveriewDetails[0]);
      }
    });
  } catch (error) {
    console.error('Error in mounted:', error);
  }
  },
};
</script>
<style scoped>
.thead-width {
  min-width: 7.8rem;
}
::v-deep .popup-width-custom .vs-popup {
  width: 1800px !important;
}
.prepaidIcon {
  background: #0077a0;
  color: rgba(255, 255, 255, 0.9);
  border-radius: 32px;
}
.postpaidIcon {
  background: rgb(0, 160, 49);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 32px;
}
th {
  padding: 0.5rem !important;
  font-size: 12px !important;
}
.popup-big ::v-deep .vs-popup {
  width: 75vw !important;
}
.card {
  background-color: #e8f7f7;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  overflow: hidden;
}

.card-content {
  padding: 24px;
}

/* Card header */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  color: #222;
}

.card-link {
  color: #0055cc;
  text-decoration: none;
  font-weight: 500;
}

.card-link:hover {
  text-decoration: underline;
}

/* Card body */
.card-body {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

/* Price section */
.price-section {
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  flex: 1;
}

.duration {
  font-weight: 600;
  margin-bottom: 12px;
}

.price {
  font-weight: bold;
  margin-bottom: 8px;
}

.price span {
  font-weight: normal;
}

.original-price {
  color: #999;
  text-decoration: line-through;
  display: inline-block;
}

.discount {
  color: #22c55e;
  margin-left: 8px;
}

/* Features section */
.features-section {
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  flex: 1;
}

.feature-list {
  list-style-type: none;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.feature-item:last-child {
  margin-bottom: 0;
}

.check-icon {
  width: 20px;
  height: 20px;
  background-color: #22c55e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.check-icon::before {
  content: "";
  width: 8px;
  height: 4px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  transform: rotate(-45deg) translate(0, -1px);
  display: block;
}

/* Checkbox section */
.checkbox-section {
  display: flex;
  align-items: flex-start;
  margin-left: 20px;
}

.checkbox {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox .check-icon {
  width: 24px;
  height: 24px;
}

/* Footer */
.card-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .card-body {
    flex-direction: column;
  }

  .checkbox-section {
    display: none;
  }
}
.price-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.old-price {
  font-size: 20px;
  color: #888;
  text-decoration: line-through;
  margin-right: 10px;
}

.current-price {
  font-size: 20px;
  font-weight: 700;
  color: #222;
}

.features {
  list-style-type: none;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  color: #333;
}

.feature-item:last-child {
  margin-bottom: 0;
}

.checkmark {
  width: 24px;
  height: 24px;
  background-color: #4cd964;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.checkmark::before {
  content: "";
  width: 10px;
  height: 6px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  transform: rotate(-45deg) translate(1px, -1px);
}

.delete-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 20px;
  height: 20px;
  color: #e74c3c;
}

.delete-icon svg {
  width: 100%;
  height: 100%;
}
</style>
<style>
.my-swal-container .swal2-html-container {
  text-align: center;
}
</style>
